/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { featurePayoutDetailConfig } from '../../config/featuresSection.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IButtonPayoutDetailContentPluginMethods
  extends IPluginMethodMap {
  getButtonPayoutDetailContentSync(args?: any): any;
}

export class ButtonPayoutDetailContentPlugin implements IAgentPlugin {
  readonly methods: IButtonPayoutDetailContentPluginMethods;

  constructor() {
    this.methods = {
      getButtonPayoutDetailContentSync:
        this.getButtonPayoutDetailContentSync.bind(this),
    };
  }

  getButtonPayoutDetailContentSync(args?: any) {
    // return {
    //   this.getButtons(args);
    // };
    return this.getButtons(args);
  }

  private async getButtons(args: any) {
    let whoami = await getWhoamiSrv()?.whoAmI();
    if (
      whoami?.whoami === 'INSURANCE_PROVIDER' &&
      !args?.purchaser?.bankDetail &&
      args?.status === 'UNPAID'
    ) {
      return featurePayoutDetailConfig?.button1;
    }
    if (
      whoami?.whoami === 'INSURANCE_PROVIDER' &&
      args?.status === 'UNPAID' &&
      args?.cyclone?.status === 'ACCEPTED'
    ) {
      return featurePayoutDetailConfig?.buttons;
    } else {
      return [];
    }
  }
}
